import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import Pusher from "pusher-js";
var GET_PUSHER_SETTINGS_QUERY = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "PusherSettingsQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "target"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "PusherTargetEnum"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "pusherSettings"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "target"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "target"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "key"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "cluster"
            },
            arguments: [],
            directives: []
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 119,
    source: {
      body: "query PusherSettingsQuery($target: [PusherTargetEnum]) {\n  pusherSettings(target: $target) {\n    key\n    cluster\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
import { MEMBER_ADDED_EVENT, MEMBER_REMOVED_EVENT, SUBSCRIPTION_ERROR_EVENT, SUBSCRIPTION_SUCCESS_EVENT } from "./constants";
import PusherContext from "./PusherContext";
import { jsx as _jsx } from "react/jsx-runtime";
// Pusher.logToConsole = process.env.NODE_ENV === 'development';

var PusherProvider = function PusherProvider(_ref) {
  var target = _ref.target,
    withAuth = _ref.withAuth,
    pusherOptions = _ref.pusherOptions,
    presenceChannel = _ref.presenceChannel,
    skip = _ref.skip,
    onError = _ref.onError,
    children = _ref.children;
  var pusher = useRef();
  var _useLazyQuery = useLazyQuery(GET_PUSHER_SETTINGS_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getPusherSettings = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    called = _useLazyQuery2$.called,
    loading = _useLazyQuery2$.loading,
    data = _useLazyQuery2$.data,
    refetch = _useLazyQuery2$.refetch;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    settingsQueryRetries = _useState2[0],
    setSettingsQueryRetries = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    connected = _useState4[0],
    setConnected = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    myActiveChannels = _useState6[0],
    setMyActiveChannels = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    presenceSubscriptionSucceeded = _useState8[0],
    setPresenceSubscriptionSucceeded = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    onlineUsersCount = _useState10[0],
    setOnlineUsersCount = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    onlineUsersIds = _useState12[0],
    setOnlineUsersIds = _useState12[1];
  useEffect(function () {
    if (!skip) {
      getPusherSettings({
        variables: {
          target: [target]
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip]);
  useEffect(function () {
    if (called && !loading) {
      if (data !== null && data !== void 0 && data.pusherSettings) {
        var _data$pusherSettings = data.pusherSettings,
          key = _data$pusherSettings.key,
          cluster = _data$pusherSettings.cluster;
        if (key) {
          try {
            pusher.current = new Pusher(key, _objectSpread({
              authEndpoint: withAuth ? '/api/auth/pusher/' : undefined,
              cluster: cluster || undefined
            }, pusherOptions));
            pusher.current.connection.bind('connected', function () {
              setConnected(true);
            });
          } catch (error) {
            console.error(error);
            if (onError) {
              onError(error);
            }
          }
        } else {
          console.error('Missing pusher key');
          if (onError) {
            onError('Missing pusher key');
          }
        }
      } else if (refetch && settingsQueryRetries < 3) {
        // Make up to 3 retries on query error
        setSettingsQueryRetries(settingsQueryRetries + 1);
        refetch();
      } else if (onError) {
        onError();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [called, loading, data]);
  var updateOnlineUsers = function updateOnlineUsers(members) {
    setOnlineUsersCount(members.count);
    setOnlineUsersIds(Object.keys(members.members).map(function (value) {
      return Number(value);
    }));
  };
  useEffect(function () {
    try {
      if (pusher.current && connected && presenceChannel) {
        var channel = pusher.current.subscribe(presenceChannel);
        channel.bind(SUBSCRIPTION_SUCCESS_EVENT, function (members) {
          setPresenceSubscriptionSucceeded(true);
          setMyActiveChannels(JSON.parse(members.me.info.channels));
          updateOnlineUsers(members);
        });
        channel.bind(MEMBER_ADDED_EVENT, function () {
          updateOnlineUsers(channel.members);
        });
        channel.bind(MEMBER_REMOVED_EVENT, function () {
          updateOnlineUsers(channel.members);
        });
        channel.bind(SUBSCRIPTION_ERROR_EVENT, function (status) {
          if (onError) {
            onError(status);
          }
        });
      }
    } catch (error) {
      console.error(error);
      if (onError) {
        onError(error);
      }
    }
    return function () {
      if (pusher.current && presenceChannel) {
        pusher.current.unsubscribe(presenceChannel);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pusher.current, connected, presenceChannel]);
  return /*#__PURE__*/_jsx(PusherContext.Provider, {
    value: {
      pusher: pusher.current,
      connected: connected,
      myActiveChannels: myActiveChannels,
      presenceSubscriptionSucceeded: presenceSubscriptionSucceeded,
      onlineUsersCount: onlineUsersCount,
      onlineUsersIds: onlineUsersIds
    },
    children: children
  });
};
export default PusherProvider;